// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableRow from "@material-ui/core/TableRow";
// import { bindActionCreators } from "redux";
// import { connect } from "react-redux";
// import { CustomPagination } from "../../Utils/Tables/CustomTable";
// import { exportPDF } from "../../Utils/exportPDF";
// import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
// import axios from "axios";
// import config from "../../Helpers/config";
// import { errorMessages } from "../../Helpers/ErrorMessages";
// import { titleCase, removeTime } from "../../Utils/titleCaseFunction";
// import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
// import { history } from "../../Helpers/history";
// import { ReusableRouteTabs } from "../../Utils/Tabs/ReusableTabs";
// import { formatAmount,formatDigits } from "../../Utils/formatAmount";
// import {
//   EnhancedTableHead,
//   EnhancedTableToolbar,
//   MuiPaper,
// } from "../../Utils/Tables/CustomTable";
// import Form from "react-bootstrap/Form";
// import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
// import styled from "@emotion/styled/macro";
// import {
//   useExcelReports,
//   usePdfReports,
// } from "../Invoice/CustomHooks/useExcelReports";

// const headData = [
//   { id: "sl", numeric: false, disablePadding: false, label: "Sl" },
//   {
//     id: "medicineName",
//     numeric: false,
//     disablePadding: false,
//     label: "Product Name",
//   },
//   { id: "strength", numeric: false, disablePadding: false, label: "Strength" },
//   {
//     id: "batch_number",
//     numeric: false,
//     disablePadding: false,
//     label: "Batch Number",
//   },
//   {
//     id: "expiry_date",
//     numeric: false,
//     disablePadding: false,
//     label: "Expiry Date",
//   },
//   {
//     id: "in_quantity",
//     numeric: false,
//     disablePadding: false,
//     label: "In Quantity",
//   },
//   {
//     id: "out_quantity",
//     numeric: false,
//     disablePadding: false,
//     label: "Sold Quantity",
//   },
//   { id: "stock", numeric: false, disablePadding: false, label: "Stock" },
//   { id: "cost_price", numeric: false, disablePadding: false, label: "Cost price" },
//   { id: "stock_price", numeric: false, disablePadding: false, label: "stockvalue" },


// ];

// const StockBatchWise = ({ actions, snackbars }) => {
//   const [stockBatch, setStockBatch] = useState({
//     data: [],
//     stockCount: 0,
//     loading: "idle",
//     total_stock_value: 0,
//   });
//   const [activePage, setActivePage] = useState(1);
//   const [searchValue, setSearchValue] = useState("");

//   useEffect(() => {
//     setStockBatch({ ...stockBatch, loading: "loading" });
  
//     axios
//       .post(`${config.epharmUrl}/Creport/active_batch`, {
//         search: searchValue,
//         page: activePage,
//         per_page: 10,
//       })
//       .then((res) => {
//         const data = res.data ?? {};
//         setStockBatch({
//           ...stockBatch,
//           data: data.data ?? [],
//           stockCount: data.total_count ?? 0,
//           total_stock_value: data.total_value ?? 0,
//           total_stock: data.total_stock ?? 0,
//           loading: "success",
//         });
//       })
//       .catch((error) => {
//         errorMessages(error, null, actions);
//         setStockBatch({ ...stockBatch, loading: "error" });
//       });
//   }, [activePage, searchValue]);
  


//   const handleChange = (event) => {
//     setSearchValue(event.target.value);
//   };

//   // const exportExcel = () => {
//   //   axios
//   //     .get(`${config.epharmUrl}/Creport/stock_batch_wise_report`, {
//   //       // params: { download: true },
//   //       responseType: "blob",
//   //     })
//   //     .then((response) => {
//   //       const url = window.URL.createObjectURL(new Blob([response.data]));
//   //       const link = document.createElement("a");
//   //       link.href = url;
//   //       link.setAttribute("download", "Stock Batchwise Report.xlsx");
//   //       document.body.appendChild(link);
//   //       link.click();
//   //     })
//   //     .catch((err) => {
//   //       errorMessages(err, null, actions);
//   //     });
//   // };

//   const downloadPDF = () => {
//     const { data } = stockBatch;
//     const batchStock = !data ? [] : data;
//     exportPDF(
//       "Stock Report(Batch Wise)",
//       [
//         [
//           "SL",
//           "Medicine Name",
//           "Strength",
//           "Batch ID",
//           "Expiry Date",
//           "InQuantity",
//           "Sold Quantity",
//           "Stock",
//         ],
//       ],
//       batchStock.map((stock, index) => [
//         (index += 1),
//         stock.product_name,
//         stock.strength,
//         stock.batch_id,
//         stock.expeire_date,
//         stock.inqty,
//         stock.outqty,
//         stock.Stock,
//       ]),
//       "Stock Report.pdf"
//     );
//   };

//   const handleCloseBar = () => {
//     actions.snackbarActions.hideSnackBar();
//   };

//   const handlePageChange = (pageNumber) => {
//     setActivePage(pageNumber);
//   };

//   const currentObj = {
//     file_name: "Stock Batchwise",
//     url: "Creport/stock_batch_wise_report_excel",
//     // params: {
//     //   download: true,
//     // },
//   };

//   const objPDF = {
//     file_name: "Stock Batchwise",
//     url: "Creport/stock_batch_wise_report_pdf",
//     // params: {
//     //   download: true,
//     // },
//   };

//   const { exportExcel } = useExcelReports(actions, currentObj);
//   const { exportPDF } = usePdfReports(actions, objPDF);

//   const { data, stockCount, total_stock_value, loading } = stockBatch;

//   const isLoading = loading === "loading";
//   const isSuccess = loading === "success";
//   const isError = loading === "error";

//   const batchStock = !data ? [] : data;
//   const { open, message, variant } = snackbars;
//   const components = [
//     { label: "Stock Report", path: "/stockreport" },
//     { label: "Stock Report(Batch Wise)", path: "/stockbatchwise" },
//   ];
//   return (
//     <div className="journals">
//       <ReusableDashboardHeader
//         component="Stock Report(Batch Wise)"
//         heading="Stock"
//         subHeading="Stock Report(Batch Wise)"
//         link={history.location.pathname}
//       />
//       <ReusableRouteTabs
//         value={history.location.pathname}
//         tabHeading={components}
//       />
//       <PharmacySnackbar
//         open={open}
//         message={message}
//         variant={variant}
//         handleCloseBar={handleCloseBar}
//       />
//       <div className="mt-4">
//         {/*<Container>*/}
//         {/*    <RightAligned>*/}
//         {/*        <Paragraph>Stock Value : <strong>{formatAmount(total_stock_value)}</strong></Paragraph>*/}
//         {/*    </RightAligned>*/}
//         {/*</Container>*/}
//         <MuiPaper>
//           <EnhancedTableToolbar title="">
//             <span className="btn-group" style={{ flex: "1 1 100%" }}>
//               <span>
//                 <button
//                   onClick={exportExcel}
//                   className="btn btn-sm pharmacy-btn mr-1"
//                 >
//                   Download Excel
//                 </button>
//               </span>

//               <span>
//                 <button
//                   className="btn btn-sm pharmacy-btn mr-1"
//                   // onClick={downloadPDF}
//                   onClick={exportPDF}
//                 >
//                   Download PDF
//                 </button>
//               </span>
//             </span>
//             <div className="mb-3 d-flex justify-content-between">
//   <div>
//     <strong>Total Stock:</strong> {formatDigits(stockBatch.total_stock) ?? 0}
//   </div>
//   <div>
//     <strong>Total Stock Value:</strong> {formatAmount(stockBatch.total_stock_value?.toFixed(2))?? 0}
//   </div>
// </div>

//             <Form.Control
//               type="text"
//               value={searchValue ? titleCase(searchValue) : ""}
//               onChange={handleChange}
//               className="form__control"
//               placeholder="Search"
//               style={{ float: "right" }}
//             />
//           </EnhancedTableToolbar>
//           <Table
//             aria-labelledby="tableTitle"
//             size="medium"
//             aria-label="enhanced table"
//           >
            
//             <EnhancedTableHead headCells={headData} />
//             <TableBody>
//               {isLoading ? (
//                 <TableRow>
//                   <TableCell colSpan={headData.length} align="center">
//                     <img
//                       src="/images/listPreloader.gif"
//                       alt="loader"
//                       style={{ width: "5%" }}
//                     />
//                   </TableCell>
//                 </TableRow>
//               ) : null}
//               {isSuccess ? (
//                 batchStock.length > 0 ? (
//                   batchStock.slice(0, 10).map((d, index) => {
//                     return (
//                       <TableRow
//                         hover
//                         role="checkbox"
//                         tabIndex={-1}
//                         key={index}
//                         className="mui-table-row"
//                       >
//                         <TableCell
//                           component="th"
//                           scope="row"
//                           padding="default"
//                           className="mui-table-cell"
//                         >
//                           <span>{index+1}</span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"product_name-" + index}>
//                             <Link
//                               to={{
//                                 pathname: `/medicinedetails/${d.product_id}`,
//                               }}
//                               style={{ color: "#09905c" }}
//                             >
//                               {titleCase(d.product_name)}
//                             </Link>
//                           </span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"strength-" + index}>
//                             {d.strength}
//                           </span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"batch_id-" + index}>
//                             {d.batch_id}
//                           </span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"expiry_date-" + index}>
//                             {d.expiry_date ? removeTime(d.expiry_date) : ""}
//                           </span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"inqty-" + index}>{formatDigits(d.in_quantity)}</span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"outqty-" + index}>
//                             {formatDigits(d.out_quantity)}
//                           </span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"stock-" + index}>{formatDigits(d.stock)}</span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"stock-" + index}>{formatDigits(d.cost_price)}</span>
//                         </TableCell>
//                         <TableCell>
//                           <span data-testid={"stock-" + index}>{formatDigits(d.stock_price)}</span>
//                         </TableCell>
//                       </TableRow>
//                     );
//                   })
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={headData.length} align="center">
//                       No records found
//                     </TableCell>
//                   </TableRow>
//                 )
//               ) : null}
//               {isError ? (
//                 <TableRow>
//                   <TableCell colSpan={headData.length} align="center">
//                     The server did not return a valid response
//                   </TableCell>
//                 </TableRow>
//               ) : null}
//             </TableBody>
//           </Table>
//           <CustomPagination
//             data={batchStock}
//             records={10}
//             activePage={activePage}
//             total_count={stockCount}
//             handleChangeNextPage={handlePageChange}
//           />
//         </MuiPaper>
//       </div>
//     </div>
//   );
// };

// function mapStateToProps(state) {
//   return {
//     snackbars: state.snackbars,
//   };
// }

// function mapDispatchToProps(dispatch) {
//   return {
//     actions: {
//       snackbarActions: bindActionCreators(snackbarActions, dispatch),
//     },
//   };
// }

// export default connect(mapStateToProps, mapDispatchToProps)(StockBatchWise);

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Form from "react-bootstrap/Form";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../Helpers/config";
import { errorMessages } from "../../Helpers/ErrorMessages";
import { titleCase, removeTime } from "../../Utils/titleCaseFunction";
import { formatAmount, formatDigits } from "../../Utils/formatAmount";
import { history } from "../../Helpers/history";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import { ReusableRouteTabs } from "../../Utils/Tabs/ReusableTabs";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPaper,
  CustomPagination,
} from "../../Utils/Tables/CustomTable";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import {
  useExcelReports,
  usePdfReports,
} from "../Invoice/CustomHooks/useExcelReports";
import { dateStringConvertT } from "../../Utils/ConvertDate";

const headData = [
  { id: "sl", numeric: false, disablePadding: false, label: "Sl" },
  { id: "medicineName", numeric: false, disablePadding: false, label: "Product Name" },
  { id: "strength", numeric: false, disablePadding: false, label: "Strength" },
  { id: "batch_number", numeric: false, disablePadding: false, label: "Batch Number" },
  { id: "expiry_date", numeric: false, disablePadding: false, label: "Expiry Date" },
  { id: "in_quantity", numeric: false, disablePadding: false, label: "In Quantity" },
  { id: "out_quantity", numeric: false, disablePadding: false, label: "Sold Quantity" },
  { id: "stock", numeric: false, disablePadding: false, label: "Stock" },
  { id: "cost_price", numeric: false, disablePadding: false, label: "Cost Price" },
  { id: "stock_price", numeric: false, disablePadding: false, label: "Stock Value" },
];

const StockBatchWise = ({ actions, snackbars }) => {
  const [stockBatch, setStockBatch] = useState({
    data: [],
    stockCount: 0,
    loading: "idle",
    total_stock_value: 0,
    total_stock: 0,
  });

  const [activePage, setActivePage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");

  const fetchData = () => {
    setStockBatch((prev) => ({ ...prev, loading: "loading" }));

    axios
      .post(`${config.epharmUrl}/Creport/active_batch`, {
        search: searchValue,
        page: activePage,
        per_page: perPage,
      })
      .then((res) => {
        const data = res.data ?? {};
        setStockBatch({
          data: data.data ?? [],
          stockCount: data.total_count ?? 0,
          total_stock_value: data.total_value ?? 0,
          total_stock: data.total_stock ?? 0,
          loading: "success",
        });
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        setStockBatch((prev) => ({ ...prev, loading: "error" }));
      });
  };

  useEffect(() => {
    fetchData();
  }, [activePage, searchValue, perPage]);

  const handleChangeSearch = (e) => {
    setSearchValue(e.target.value);
    setActivePage(1);
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setActivePage(1);
  };

  const { exportExcel } = useExcelReports(actions, {
    file_name: "Stock Batchwise",
    url: "Creport/stock_batch_wise_report_excel",
  });

  const { exportPDF } = usePdfReports(actions, {
    file_name: "Stock Batchwise",
    url: "Creport/stock_batch_wise_report_pdf",
  });

  const { data, stockCount, total_stock_value, total_stock, loading } = stockBatch;
  const { open, message, variant } = snackbars;

  const components = [
    { label: "Stock Report", path: "/stockreport" },
    { label: "Stock Report (Batch Wise)", path: "/stockbatchwise" },
  ];

  const isLoading = loading === "loading";
  const isError = loading === "error";
  const isSuccess = loading === "success";

  return (
    <div className="journals">
      <ReusableDashboardHeader
        component="Stock Report (Batch Wise)"
        heading="Stock"
        subHeading="Stock Report (Batch Wise)"
        link={history.location.pathname}
      />
      <ReusableRouteTabs value={history.location.pathname} tabHeading={components} />
      <PharmacySnackbar open={open} message={message} variant={variant} handleCloseBar={() => actions.snackbarActions.hideSnackBar()} />
          {/* Totals Display */}
          <div className="d-flex justify-content-between border-top pt-2">
            <div><strong>Total Stock:</strong> {formatDigits(total_stock)}</div>
            <div><strong>Total Stock Value:</strong> {formatAmount(total_stock_value.toFixed(2))}</div>
          </div>
      <MuiPaper>
        <EnhancedTableToolbar title="Stock Batchwise Report">
          <div className="d-flex justify-content-between align-items-center w-100 mb-2">
            <div className="d-flex gap-2">
              <button onClick={exportExcel} className="btn btn-sm pharmacy-btn mr-1">
                Download Excel
              </button>
              <button onClick={exportPDF} className="btn btn-sm pharmacy-btn mr-1">
                Download PDF
              </button>
            </div>
            <Form.Control
              type="text"
              value={titleCase(searchValue)}
              onChange={handleChangeSearch}
              className="form__control"
              placeholder="Search by name, batch or reference"
              style={{ maxWidth: "300px" }}
            />
          </div>


        </EnhancedTableToolbar>

        {/* Scrollable Table */}
        <TableContainer component={Paper} style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Table stickyHeader aria-label="stock batchwise table">
            <EnhancedTableHead headCells={headData} />
            <TableBody>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    <img src="/images/listPreloader.gif" alt="Loading..." style={{ width: "5%" }} />
                  </TableCell>
                </TableRow>
              )}

              {isSuccess && data.length > 0 ? (
                data.map((d, index) => (
                  <TableRow hover key={index}>
                    <TableCell>{(activePage - 1) * perPage + index + 1}</TableCell>
                    <TableCell>
                      <Link to={`/medicinedetails/${d.product_id}`} style={{ color: "#09905c" }}>
                        {titleCase(d.product_name)}
                      </Link>
                    </TableCell>
                    <TableCell>{d.strength}</TableCell>
                    <TableCell>{d.batch_number}</TableCell>
                    <TableCell>{d.expiry_date ? dateStringConvertT(d.expiry_date) : ""}</TableCell>
                    <TableCell>{formatDigits(d.in_quantity)}</TableCell>
                    <TableCell>{formatDigits(d.out_quantity)}</TableCell>
                    <TableCell>{formatDigits(d.stock)}</TableCell>
                    <TableCell>{formatDigits(d.cost_price)}</TableCell>
                    <TableCell>{formatDigits(d.stock_price)}</TableCell>
                  </TableRow>
                ))
              ) : (
                !isLoading &&
                !isError && (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      No records found
                    </TableCell>
                  </TableRow>
                )
              )}

              {isError && (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    Server did not return a valid response.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <div className="d-flex justify-content-between align-items-center p-3">
          <div className="d-flex align-items-center">
            <span className="mr-2"><strong>Rows per page:</strong></span>
            <Form.Control
              as="select"
              value={perPage}
              onChange={handlePerPageChange}
              style={{ width: "80px" }}
            >
              {[10, 20, 50, 100].map((num) => (
                <option key={num} value={num}>{num}</option>
              ))}
            </Form.Control>
          </div>

          <CustomPagination
            data={data}
            records={perPage}
            activePage={activePage}
            total_count={stockCount}
            handleChangeNextPage={handlePageChange}
          />
        </div>
      </MuiPaper>
    </div>
  );
};

function mapStateToProps(state) {
  return { snackbars: state.snackbars };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StockBatchWise);
